export class ContactInfo {
    name:string;
    surname:string;
    phone:string;
    email:string;
    comments:string = '';

    constructor(other ?:ContactInfo) {
        if (other) {
            this.name = other.name;
            this.surname = other.surname;
            this.phone = other.phone;
            this.email = other.email;
            this.comments = other.comments;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/contactInfo.ts
 **/